import React, { useState } from 'react';
import './index.css';

type Position = "left" | "center" | "right" | "top" | "fullTop" | "bottom";
type Trigger = "click" | "hover" | "none";

interface Props {
    content?: React.ReactNode,
    position?: Position,
    trigger?: Trigger,
    width?: string,
    maxWidth?: string,
    border?: string,
    id?: string
    top?: boolean,
    tooltipColor?: string,
}

const LcTooltip: React.FC<Props> = (props) => {
    const [visible, setVisible] = useState<boolean>(false);
    const [topTooltip, setTopTooltip] = useState<boolean>(false)

    const handleVisible = (event) => {
        props.trigger === 'hover' && setVisible(true);
        if (event.screenY > 600) setTopTooltip(true);
    }

    return (
        <div
            id={(props.id) ? props.id : ''}
            className={`lc-tooltip${props.top ? ' top' : ''}`}
            onClick={() => (!props.trigger || props.trigger === 'click') && setVisible(!visible)}
            onMouseOver={(e) => handleVisible(e)}
            onMouseLeave={() => setVisible(false)}
            style={{ width: (props.width) ? props.width : "fit-content" }}
        >
            {
                !props.top &&
                props.children
            }
            {
                visible &&
                <div className={`body ${props.position}`}>
                    <div
                        className="contentTooltip"
                        style={{
                            maxWidth: (props.maxWidth) ? props.maxWidth : "230px",
                            border: (props.border) ? props.border : undefined,
                            backgroundColor: (props.tooltipColor) ? props.tooltipColor : undefined
                        }}>
                        {props.content}
                    </div>
                    <span className="arrow"
                        style={{
                            borderTop: (props.border) ? props.border : undefined,
                            borderLeft: (props.border) ? props.border : undefined,
                            backgroundColor: (props.tooltipColor) ? props.tooltipColor : undefined
                        }}
                    />
                </div>
            }
            {
                props.top &&
                props.children
            }
        </div>
    );
}

export default LcTooltip;